import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { BookOpen } from "lucide-react";
import {
  clearTeacherSession,
  setTeacherLogoutModal,
} from "../../features/teacher/teacherSlice";

const modalStyles = `
  .teacher-session-expired-overlay {
    position: fixed;
    inset: 0;
    z-index: 140;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1.25rem;
    background: rgba(24, 19, 15, 0.56);
    backdrop-filter: blur(8px);
  }

  .teacher-session-expired-card {
    width: min(100%, 28rem);
    border: 1px solid #eadfce;
    border-radius: 1.5rem;
    background:
      radial-gradient(circle at top left, rgba(255, 194, 142, 0.22), transparent 30%),
      linear-gradient(180deg, #fffdf8 0%, #fbf5eb 100%);
    box-shadow: 0 30px 50px rgba(44, 33, 18, 0.2);
    padding: 1.5rem;
    color: #1f1a17;
    font-family: "Lato", sans-serif;
    text-align: center;
  }

  .teacher-session-expired-badge {
    width: 3rem;
    height: 3rem;
    border-radius: 999px;
    display: grid;
    place-items: center;
    background: linear-gradient(135deg, #ff7154 0%, #ff564d 100%);
    color: #ffffff;
    box-shadow: 0 12px 20px rgba(255, 98, 77, 0.22);
    margin: 0 auto 1rem;
  }

  .teacher-session-expired-title {
    margin: 0 0 0.55rem;
    font-size: 1.35rem;
    font-weight: 800;
    text-align: center;
  }

  .teacher-session-expired-copy {
    margin: 0;
    color: #67615c;
    line-height: 1.6;
    text-align: center;
  }

  .teacher-session-expired-action {
    margin-top: 1.25rem;
    width: 100%;
    min-height: 3.2rem;
    border: 0;
    border-radius: 0.95rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #ff7154 0%, #ff564d 100%);
    box-shadow: 0 18px 28px rgba(255, 98, 77, 0.22);
    color: #ffffff;
    font: inherit;
    font-size: 0.98rem;
    font-weight: 800;
    cursor: pointer;
  }
`;

export default function TeacherLogoutModal() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLoginAgain = () => {
    dispatch(clearTeacherSession());
    dispatch(setTeacherLogoutModal(false));
    navigate("/teacherlogin", { replace: true });
  };

  return (
    <>
      <style>{modalStyles}</style>
      <div className="teacher-session-expired-overlay" role="dialog" aria-modal="true">
        <div className="teacher-session-expired-card">
          <div className="teacher-session-expired-badge" aria-hidden="true">
            <BookOpen size={20} />
          </div>
          <h2 className="teacher-session-expired-title">Session expired</h2>
          <p className="teacher-session-expired-copy">
            You were logged out after 10 minutes of inactivity. Please log in again
            to continue in the teacher portal.
          </p>
          <button
            type="button"
            className="teacher-session-expired-action"
            onClick={handleLoginAgain}
          >
            Back to Teacher Login
          </button>
        </div>
      </div>
    </>
  );
}
